angular.module('project')
    .component('projectsDisplay', {
        bindings: {
            projects: '<',
            noIcons: '<',
            showGc: '<'
        },
        templateUrl: 'app/project/display.html',
        controller(toastr, ProjectService, Principal, ProjectConst) {
            this.$onChanges = () => {
                this.canRead = Principal.hasAnyAuthority([ProjectConst.role])
                this.canWrite = Principal.hasAnyAuthority([ProjectConst.roleWrite])
            }

            this.openProject = (id) => {
                if(!this.canRead){
                    toastr.warning("Brak uprawnień do modułu Projekty")
                    return
                }
                ProjectService.show(id)
            }
        }
    })

